<template>
    <div class="container remove-padding-margin" id="worksetpage">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back()">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Pengaturan Pekerjaan</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
        <main class="">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="add-padding-default border-btm" style="padding-bottom: 16px">
                        <div class="set-small-text color-33333 font-16">
                            Pilih jenis pekerjaan (bisa lebih dari satu)
                        </div>
                    </div>
                    <div class="custom-control custom-checkbox add-padding-default border-btm pad-top-bot-15">
                        <div @click="bonus">
                            <input type="checkbox" class="custom-control-input" id="outletworkset">
                            <label class="custom-control-label" for="outletworkset" id="labelOutlet">Bekerja sebagai Kasir</label>
                        </div>
                        <div class="" id="contentoutletworkset">
                            <div class="text-div-outlet mar-top-20">Bertugas memproses pembuatan, penyelesaian ataupun pembatalan transaksi outlet.
                            </div>
                            <label class="remove-margin mar-top-12 require" for="listoutlet">Pilih Outlet</label>
                            <Select2 class="test-select fl-is-required inputs mod" id="select2"
                                     v-model="idoutlet" :options="optionoutlet"
                                     :settings="{ placeholder: 'Pilih Outlet' }"
                                     @change="myChangeEvent($event)" v-on:change="cekValidate"/>
                        </div>
                    </div>

                    <div class="custom-control custom-checkbox add-padding-default pad-top-bot-15 border-btm">
                        <div @click="workshopp">
                            <input type="checkbox" class="custom-control-input" id="workshopworkset">
                            <label class="custom-control-label" for="workshopworkset">Bekerja di Workshop</label>
                        </div>
                        <div class="" id="contentworkshopworkset">
                            <div id="jenis-workshop">
                                <label class="remove-margin mar-top-12 require" for="listworkshop">Pilih
                                    Workshop</label>
                                <Select2 class="test-select fl-is-required inputs mod" id="select1"
                                         v-model="idworkshop" :options="optionworkshop"
                                         :settings="{ placeholder: 'Pilih Workshop' }"
                                         @change="myChangeEventworkshop($event)" v-on:change="cekValidate"/>
                                <div class="jenis-pekerjaan">Pilih Jenis Pekerjaan</div>
                                <div>Pilih jenis pekerjaan yang dapat diproses oleh karyawan di aplikasi produksi. Hanya
                                    pekerjaan terpilih yang bisa diproses
                                </div>
                                <div class="custom-control custom-checkbox remove-padding" v-for="data in checklisttahapan"
                                     :key="data.idtahapan">
                                    <input type="checkbox" @click="borongan(data.idtahapan)" class="custom-control-input checkBox" v-if="data.status == '1'" :value="data.idtahapan" v-bind:id="data.idtahapan" v-model="pekerjaanTemp">
                                    <input type="checkbox" @click="borongan(data.idtahapan)" class="custom-control-input" v-else-if="data.status == '0'" disabled>
                                    <input type="checkbox" @click="borongan(data.idtahapan)" class="custom-control-input" v-else disabled>
                                    <label class="custom-control-label label-checklist" v-if="data.status=='0'" v-bind:for="data.idtahapan" v-on:click="showalertdissable">
                                        {{data.text}}</label>
                                    <label class="custom-control-label label-checklist" v-bind:for="data.idtahapan"
                                           v-if="data.status=='1'  && data.idtahapan == 8000"
                                           v-on:click="showalertpengemasaan">
                                        {{data.text}}</label>
                                    <label class="custom-control-label label-checklist" v-bind:for="data.idtahapan" v-else-if="data.status=='1'">
                                        {{data.text}}</label>
                                    <div class="custom-control custom-checkbox borongan" style="padding: 0px 12px;display: none" :id="'borongan'+ data.idtahapan">
                                        <input type="checkbox" class="custom-control-input" :id="'boronganCheck'+ data.idtahapan"  :value="data.idtahapan + 'dibayar'" v-model="dibayarTemp">
                                        <label class="custom-control-label label-checklist" v-bind:for="'boronganCheck'+ data.idtahapan">Menerima Upah Borongan</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="custom-control custom-checkbox add-padding-default border-btm pad-top-bot-15"
                         id="checkkurirworkset">
                        <div @click="kurir">
                            <input type="checkbox" class="custom-control-input" id="kurirworkset">
                            <label class="custom-control-label" id="labelKurir" for="kurirworkset">Bekerja sebagai Kurir</label>
                        </div>
                        <div id="content-kasir-workset">
                            <div class="text-div-outlet mar-top-20">Bertugas untuk mengirim atau mengambil barang. Pada
                                outlet, workshop maupun konsumen.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button-lanjut add-padding-default">
                    <button class="btn btn-login btn-long remove-margin" :disabled="!validateAccess('job.update')" id="btnsetwork" @click="post">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span><span id="textbtnsetwork">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';

    export default {
        props:['setidkaryawan'],
        name: "WorkSet",
        components: {Select2},
        data() {
            return {
                idkaryawan:this.setidkaryawan,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                karyawan:[],
                outlet:[],
                optionoutlet:[],
                workshop:[],
                optionworkshop:[],
                isClicked:false,
                selected:'',
                selectedworkshop:'',
                myValue:'',
                datatahapan:[],
                checklisttahapan:[],
                dataProses:[],
                dataCheckTahapan: [],
                statusoutletworkset: '0',
                statusworkshopworkset:'0',
                idoutlet:'',
                idworkshop:'',
                statuskurirworkset:'0',
                pekerjaanTemp:[],
                dibayarTemp:[],
                workChecked:[],
                worksetCheckedTemp:[],
            }
        },
        mounted() {
            this.idkaryawan = this.$route.params.idkaryawan
            // $('#btnsetwork').prop('disabled', false);
            // this.smartTrackingView("pengaturan_pekerjaan_karyawan",{"idkaryawan":this.idkaryawan});

        },
        methods: {
            back() {
                this.$emit("isdetail")
	            $("#outletworkset").prop("checked", false)
	            $("#workshopworkset").prop("checked", false)
	            $("#kurirworkset").prop("checked", false)
	
	            this.clearData()
            },
	        clearData() {
		        this.karyawan = []
		        this.outlet = []
		        this.optionoutlet = []
			    this.workshop = []
		        this.optionworkshop = []
		        this.isClicked = false
		        this.selected = ''
		        this.selectedworkshop = ''
		        this.myValue = ''
		        this.datatahapan = []
		        this.checklisttahapan = []
		        this.dataProses = []
		        this.dataCheckTahapan = []
		        this.statusoutletworkset = '0'
			    this.statusworkshopworkset = '0'
			    this.idoutlet = ''
		        this.idworkshop = ''
			    this.statuskurirworkset = '0'
		        this.pekerjaanTemp = []
		        this.dibayarTemp = []
		        this.workChecked = []
		        this.worksetCheckedTemp = []
	        },
            showalertdissable(){
            	this.$toast.error("Workshop tidak mengaktifkan jenis pekerjaan ini. Atur dihalaman workshop untuk mengaktifkannya.")
            },

            showalertpengemasaan() {
                this.worksetCheckedTemp = [];
                var pekerjaanCheked = null;
                var inputElements = document.getElementsByClassName('checkBox');
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].checked) {
                        pekerjaanCheked = inputElements[i].id;
                        this.worksetCheckedTemp.push({
                            idtahapan: pekerjaanCheked,
                        })
                    }
                }

                var dataTemp = this.worksetCheckedTemp;
                var arraTemp = [];
                for(var x = 0; x < dataTemp.length; x++ ){
                    arraTemp.push(dataTemp[x].idtahapan)
                }

                var bool = arraTemp.indexOf("8000");
                if (bool < 0){
                
                }else{
                	this.$toast.error("Mohon pastikan telah ada minimal 1 karyawan yang melakukan pengemasan")
                }

            },

            cekValidate() {
            	return
                var kota = this.selectedworkshop;
                var outlet = this.selected;
                var statusw = this.statusworkshopworkset;
                var statuso = this.statusoutletworkset;
                var statusk = this.statuskurirworkset;
                if (statusw === '1') {
                    if (statuso === '1') {
                        if (kota !== '' && outlet !== '') {
                            // this.worksetCheckedTemp = [];
                            // var pekerjaanCheked = null;
                            // var inputElements = document.getElementsByClassName('checkBox');
                            // for (var i = 0; inputElements[i]; ++i) {
                            //     if (inputElements[i].checked) {
                            //         pekerjaanCheked = inputElements[i].id;
                            //         this.worksetCheckedTemp.push({
                            //             idtahapan: pekerjaanCheked,
                            //         })
                            //     }
                            // }
                            if (this.worksetCheckedTemp.length > 0) {
                                $('#btnsetwork').prop('disabled', false);
                            } else {
	                            if (this.pekerjaanTemp.length > 0) {
		                            $('#btnsetwork').prop('disabled', false);
	                            } else {
		                            $('#btnsetwork').prop('disabled', true);
	                            }
                            }
                        } else {
                            $('#btnsetwork').prop('disabled', true);
                        }
                    } else {
                        if (kota !== '') {
                            this.worksetCheckedTemp = [];
                            var pekerjaanCheked = null;
                            var inputElements = document.getElementsByClassName('checkBox');
                            for (var i = 0; inputElements[i]; ++i) {
                                if (inputElements[i].checked) {
                                    pekerjaanCheked = inputElements[i].id;
                                    this.worksetCheckedTemp.push({
                                        idtahapan: pekerjaanCheked,
                                    })
                                }
                            }
                            if (this.worksetCheckedTemp.length > 0) {
                                $('#btnsetwork').prop('disabled', false);
                            } else {
                                $('#btnsetwork').prop('disabled', true);
                            }
                        } else {
	                        if (this.pekerjaanTemp.length > 0) {
		                        $('#btnsetwork').prop('disabled', false);
	                        } else {
		                        $('#btnsetwork').prop('disabled', true);
	                        }
                        }
                    }
                } else if (statuso === '1') {
                    if (statusw === '1') {
                        if (kota !== '' && outlet !== '') {
                            $('#btnsetwork').prop('disabled', false);
                        } else {
                            $('#btnsetwork').prop('disabled', true);
                        }
                        this.worksetCheckedTemp = [];
                        var pekerjaanCheked = null;
                        var inputElements = document.getElementsByClassName('checkBox');
                        for (var i = 0; inputElements[i]; ++i) {
                            if (inputElements[i].checked) {
                                pekerjaanCheked = inputElements[i].id;
                                this.worksetCheckedTemp.push({
                                    idtahapan: pekerjaanCheked,
                                })
                            }
                        }
                        if (this.worksetCheckedTemp.length > 0) {
                            $('#btnsetwork').prop('disabled', false);
                        } else {
                            $('#btnsetwork').prop('disabled', true);
                        }
                    } else {
                        if (outlet !== '') {
                            $('#btnsetwork').prop('disabled', false);
                        } else {
                            $('#btnsetwork').prop('disabled', true);
                        }
                    }

                } else if (statusk === '1') {
                    if (statusw === '1' && statuso === '1') {
                        if (kota !== '' && outlet !== '') {
                            $('#btnsetwork').prop('disabled', false);
                        } else {
                            $('#btnsetwork').prop('disabled', true);
                        }
                        this.worksetCheckedTemp = [];
                        var pekerjaanCheked = null;
                        var inputElements = document.getElementsByClassName('checkBox');
                        for (var i = 0; inputElements[i]; ++i) {
                            if (inputElements[i].checked) {
                                pekerjaanCheked = inputElements[i].id;
                                this.worksetCheckedTemp.push({
                                    idtahapan: pekerjaanCheked,
                                })
                            }
                        }
                        if (this.worksetCheckedTemp.length > 0) {
                            $('#btnsetwork').prop('disabled', false);
                        } else {
                            $('#btnsetwork').prop('disabled', true);
                        }
                    } else {
                        $('#btnsetwork').prop('disabled', false);
                    }
                } else {
                    $('#btnsetwork').prop('disabled', true);
                }

            },

            saveChange(){
                this.workChecked = [];
                var pekerjaanCheked = null;
                var inputElements = document.getElementsByClassName('checkBox');
                for (var i = 0; inputElements[i]; ++i) {
                    if (inputElements[i].checked) {
                        pekerjaanCheked = inputElements[i].id;
                        var upahId = document.getElementById("boronganCheck" + pekerjaanCheked);
                        var upahCheked = 1;
                        if (upahId.checked) {
                            upahCheked = 2;
                        }
                        this.workChecked.push({
                            idtahapan: pekerjaanCheked,
                            dibayar: upahCheked,
                        })
                    }
                }
            },
            
            async post(){
            	if (!$("#outletworkset").is(":checked") && !$("#workshopworkset").is(":checked") && !$("#kurirworkset").is(":checked")) {
		            this.$toast.error("Pilih salah satu pekerjaan")
            		return
	            }
	            if ($("#outletworkset").is(":checked") && this.idoutlet === "") {
		            this.$toast.error("Outlet tidak boleh kosong")
		            return
	            }
	            if ($("#workshopworkset").is(":checked") && this.idworkshop === "") {
		            this.$toast.error("Workshop tidak boleh kosong")
		            return
	            }
                this.isClicked=true
                $('#btnsetwork').prop('disabled', true);
                $('#textbtnsetwork').hide();
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading')
                this.saveChange()
              try {
                  var pekerjaan = this.workChecked
                  var editpekerjaan = {
                          "status_karyawan_outlet": this.statusoutletworkset,
                          "karyawan_outlet_detail":{
                              "outlet_idoutlet" : this.idoutlet
                          },
                          "status_karyawan_kurir": this.statuskurirworkset,
                          "status_karyawan_workshop": this.statusworkshopworkset,
                          "karyawan_workshop_detail":{
                              "workshop_idworkshop": this.selectedworkshop,
                              "pekerjaan": pekerjaan
                          }
                      }
                  const res = await this.$axios.post(this.$baseurl + '/masterData/karyawan/update_pengaturan_pekerjaan?idkaryawan=' + this.setidkaryawan,JSON.stringify(editpekerjaan) ,{
                      headers: {
                          'Content-type': 'application/json',
                          'Authorization': 'Bearer ' + localStorage.getItem('token'),
                      }
                  })
                  if (res.status === 200) {
                      if(res.data.status===true){
                          this.optionworkshop = []
                          this.isClicked=false
                          $('#btnsetwork').prop('disabled', false);
                          $('#textbtnsetwork').show();
                          this.back()
	                      this.$toast.success(res.data.msg)
                          $('#loadingPage').removeClass('overlayLoading')
                          $('#loadingPage').hide()
                      }else{
                      	  this.$toast.error(res.data.msg)
                          $('#btnsetwork').prop('disabled', false);
                          $('#textbtnsetwork').show();
                          $('#loadingPage').removeClass('overlayLoading')
                          $('#loadingPage').hide()
                      }
                  }
              }  catch (e) {
	              this.$catch_error_response(e)
	              this.isClicked=false
	              $('#btnsetwork').prop('disabled', false);
	              $('#textbtnsetwork').show();
	              $('#loadingPage').removeClass('overlayLoading');
	              $('#loadingPage').hide()
              }
                this.smartTrackingClick("simpan_pengaturan_pekerjaan_karyawan",{"idkaryawan":this.idkaryawan});

            },

            bonus(e) {
                e.preventDefault()
                if (!$('#outletworkset').is(":checked")) {
                    $('#contentoutletworkset').slideDown(400);
                    $('#outletworkset').prop('checked', true)
                    this.statusoutletworkset = '1'
                } else {
	                if ($("#kurirworkset").is(":checked")) {
		                this.kurir(e)
	                }
                    $('#contentoutletworkset').slideUp(400);
                    $('#outletworkset').prop('checked', false)
                    this.statusoutletworkset = '0'
                }
                this.cekValidate()
            },
            workshopp(e) {
                e.preventDefault()
                if (!$('#workshopworkset').is(":checked")) {
                    $('#contentworkshopworkset').slideDown(400);
                    $('#workshopworkset').prop('checked', true)
                    this.statusworkshopworkset = '1'
                } else {
                    $('#contentworkshopworkset').slideUp(400);
                    $('#workshopworkset').prop('checked', false)
                    this.statusworkshopworkset = '0'
                }
                this.cekValidate()
            },
            kurir(e) {
                e.preventDefault()
                if (!$('#kurirworkset').is(":checked")) {
	                if (!$("#outletworkset").is(":checked")) {
	                	this.bonus(e)
	                }
                    $('#content-kasir-workset').slideDown(400);
                    $('#kurirworkset').prop('checked', true)
                    this.statuskurirworkset = '1'
                } else {
                    $('#content-kasir-workset').slideUp(400);
                    $('#kurirworkset').prop('checked', false)
                    this.statuskurirworkset = '0'
                }
                this.cekValidate()
            },
            borongan(id) {
                if (!$('#' + id).is(":checked")) {
                    $('#borongan' + id).slideUp(400);
                    $('#' + id).prop('checked', false)
                } else {
                    $('#borongan' + id).slideDown(400);
                    $('#' + id).prop('checked', true)
                }
                this.cekValidate()
            },

            myChangeEvent(val) {
	            this.selected = val
                this.myValue = val
            },
            myChangeEventworkshop(val) {
                this.myValue = val
	            this.selectedworkshop = val
                this.getChecklist()

            },

            async listoutlet() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_meta?limit=50&idowner=' + idowner, this.requestHeaders)
                    if (res.status === 200) {
                        var rawoutlet = res.data.data;
                        this.optionoutlet.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < rawoutlet.length; i++) {
                            this.optionoutlet.push({id: rawoutlet[i].idoutlet, text: rawoutlet[i].nama})
                        }
                    }
                    $('#loadingPage').hide();
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide();
                }
            },
            async getWorkshop() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_meta?idowner=' + idowner, this.requestHeaders)
                    if (res.status === 200) {
                        $('#loadingPage').hide();
                        var rawworkshop = res.data.data;
                        this.optionworkshop.push({id: "", text: "Pilih Workshop"})
                        for (var i = 0; i < rawworkshop.length; i++) {
                            this.optionworkshop.push({id: rawworkshop[i].idworkshop, text: rawworkshop[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
                }
                $('#loadingPage').removeClass('overlayLoading');
                this.isClicked = false;
            },

            async getdetailpekerjaan() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_pengaturan_pekerjaan?idkaryawan=' + this.setidkaryawan, this.requestHeaders)
                    // this.karyawan = response.data.data
                    if (response.status === 200) {
                        $('#loadingPage').hide();
                        if (response.data.status === true) {
                            var res = response.data.data
                            setTimeout(()=>{
                            	if (res.workshop.length > 0) {
	                                var dataPekerjaan = res.workshop[0].pekerjaan_karyawan
	                                for (var i = 0; i < dataPekerjaan.length; i++) {
	                                    this.pekerjaanTemp.push(dataPekerjaan[i].tahapan_idtahapan)
	                                    $('#borongan' + dataPekerjaan[i].tahapan_idtahapan).slideDown(400);
	                                    $('#' + dataPekerjaan[i].tahapan_idtahapan).prop('checked', true);
	                                    if (dataPekerjaan[i].dibayar === 2){
	                                        this.dibayarTemp.push(dataPekerjaan[i].tahapan_idtahapan+"dibayar")
	                                    }
	                                }
	                            }
                                this.cekValidate()
                            },500)

                            if (res.status_karyawan_outlet === 1) {
                                this.idoutlet = res.outlet[0].outlet_idoutlet;
                                $("#contentoutletworkset").slideDown(400)
                                $('#outletworkset').prop('checked', true)
                                this.statusoutletworkset = '1'
                                this.selected = this.idoutlet
                            } else {
                                $('#outletworkset').prop('checked', false)
                                $("#contentoutletworkset").hide()
                            }
                            if (res.status_karyawan_workshop === 1) {
                                this.idworkshop = res.workshop[0].workshop_idworkshop;
                                $('#workshopworkset').prop('checked', true)
                                this.statusworkshopworkset = '1'
                                this.selectedworkshop = this.idworkshop
                                this.myValue = this.idworkshop
                                $("#contentworkshopworkset").slideDown(400)
	                            $("#listworkshop").show()
                                this.getChecklist()
                            } else {
                                $('#workshop').prop('checked', false)
                                $("#contentworkshopworkset").hide()
                            }
                            if (res.status_karyawan_kurir === 1) {
                                this.statuskurirworkset = '1';
                                $("#content-kasir-workset").slideDown(400)
                                $('#kurirworkset').prop('checked', true)
                            } else {
                                $('#kurirworkset').prop('checked', false)
                                this.statuskurirworkset = '0';
                                $("#content-kasir-workset").hide()
                            }
                            // if (res.status_karyawan_kurir === 1) {
                            //     $('#kurir').prop('checked', true)
                            // } else {
                            //     $('#kurir').prop('checked', false)
                            // }

                            if (res.workshop.length > 0) {
	                            var dataPekerjaan = res.workshop[0].pekerjaan_karyawan
	                            for (var i = 0; i < dataPekerjaan.length; i++) {
		                            this.pekerjaanTemp.push(dataPekerjaan[i].tahapan_idtahapan)
	                            }
                            }

                        }
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async gettahapan() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                $('.borongan').hide()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_meta')
                    if (response.status === 200) {
                        $('#loadingPage').hide();
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            this.datatahapan.push({idtahapan: rawtahapan[i].idtahapan, text: rawtahapan[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
                }
            },

            async getChecklist() {
                this.dataCheckTahapan = [];
                this.dataProses = []
                this.checklisttahapan = []
                this.pekerjaanTemp = []
                this.dibayarTemp = []
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_workshop_meta?idworkshop=' + this.idworkshop, this.requestHeaders)
                    if (response.status === 200) {
                        $('#loadingPage').hide();
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            this.dataCheckTahapan.push({idtahapan: rawtahapan[i].idtahapan})
                            this.dataProses.push(rawtahapan[i].idtahapan)
                        }
                    }
                    const response2 = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_meta')
                    if (response2.status === 200) {
                        $('#loadingPage').hide();
                        var arrayTahapan = this.dataCheckTahapan;
                        var rawtahapan2 = response2.data.data;
                        for (var y = 0; y < rawtahapan2.length; y++) {
                            var status = this.checkValue(rawtahapan2[y].idtahapan, arrayTahapan)
                            this.checklisttahapan.push({
                                idtahapan: rawtahapan2[y].idtahapan,
                                text: rawtahapan2[y].nama,
                                status: status
                            })
                        }


                        setTimeout(()=>{
                            var pekerjaanCheked = this.pekerjaanTemp;
                            for (var x = 0; x < pekerjaanCheked.length; x++) {
                                $("#cek" + pekerjaanCheked[x].idtahapan).hide()
                                // $('#borongan8000').slideDown(400); // iki lho seng 8000 iku
                            }
                        },500)

                    }
                    $('.borongan').hide()
                    $('#loadingPage').hide();
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
                    $('#textBtn2').show()
                    $('#btnNext').prop('disabled', false)
                }
            },

            checkValue(value, arr) {
                var status = '0';

                for (var i = 0; i < arr.length; i++) {
                    var name = arr[i].idtahapan;
                    if (name == value) {
                        status = '1';
                        break;
                    }
                }

                return status;
            },
        }
    }
</script>

<style scoped>
    .text-div-outlet {
        font-size: 16px;
        line-height: 25px;
        letter-spacing: -0.02em;
        color: #6F7287;
    }

    .border-btm {
        border-bottom: 1px solid #EDEDED;;
    }

    .jenis-akses {
        margin-top: 16px;
        margin-bottom: 2px;
        font-weight: bold;
    }

    .jenis-pekerjaan {
        margin-top: 16px;
        margin-bottom: 2px;
        font-weight: bold;
    }

    .alert-custome{
        background: #FCF4D9;
        box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.07);
        border-radius: 3px;
        border: 1px solid #F6BC88;
    }
</style>